import { render, staticRenderFns } from "./ReservationFares.vue?vue&type=template&id=0dbd9482&"
import script from "./ReservationFares.vue?vue&type=script&lang=js&"
export * from "./ReservationFares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports